export class Role {
  constructor(
    public name: string,
    public checked: boolean,
    public deleted: boolean,
    public info: string,
    public oid: number
  ) {}
}

export enum Roles {
  ALLOW_REPORTING_ACCESS = 'Manager - Allow reporting access',
  // Can be removed once all servers are updated and return the new role.
  BACKWARDS_COMPATIBILITY_ALLOW_REPORTING_ACCESS = 'Allow reporting access',
  ALLOW_PRODUCT_ACCESS = 'Manager - Allow product access',
  // Can be removed once all servers are updated and return the new role.
  BACKWARDS_COMPATIBILITY_ALLOW_PRODUCT_ACCESS = 'Allow product access'
}
